import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import './RowItemText.scss';

const RowItemText = React.memo(
  ({ className, text, href, onClick, contentModifer, qaTag, isDisabled, badge }) => {
    let content = text;

    if (href || onClick) {
      const props = {
        'aria-disabled': isDisabled,
        className: 'RowItemText',
        'data-qa': qaTag,
        onClick,
        tabIndex: isDisabled ? '-1' : '0',
        to: href,
      };
      content = <Link {...props}>{text}</Link>;
    }

    if (text || contentModifer) {
      return (
        <div className={className} data-qa={(!href && qaTag) || ''}>
          {contentModifer} {content}
          {badge}
        </div>
      );
    }

    return '';
  },
);

RowItemText.propTypes = {
  badge: PropTypes.node,
  className: PropTypes.string,
  contentModifer: PropTypes.node,
  href: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  qaTag: PropTypes.string,
  text: PropTypes.node,
};

export default RowItemText;
